import type { JSX } from 'react';
import { Chip } from '@heroui/react';

import type { TeamRole } from '~/types';

interface TeamRoleBadgeProps {
  role: TeamRole;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Color mapping for team roles:
 * - team_admin: blue (primary)
 * - team_member: gray (default)
 */
const teamRoleColors: Record<TeamRole, 'primary' | 'default'> = {
  team_admin: 'primary',
  team_member: 'default',
};

/**
 * Display labels for team roles.
 */
const teamRoleLabels: Record<TeamRole, string> = {
  team_admin: 'Team Admin',
  team_member: 'Team Member',
};

export function TeamRoleBadge({ role, size = 'sm' }: TeamRoleBadgeProps): JSX.Element {
  return (
    <Chip color={teamRoleColors[role]} size={size}>
      {teamRoleLabels[role]}
    </Chip>
  );
}
